import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: for navigation buttons
import "swiper/css/pagination";
import evelu from "../../../assets/images/evelu.svg";
import Avatar00 from "../../../assets/images/Avatar00.webp";
import start_rating from "../../../assets/images/start_rating.webp";
import tar1 from "../../../assets/images/tar1.webp";
import tar2 from "../../../assets/images/tar2.webp";
import tar3 from "../../../assets/images/tar3.webp";
export default function Evaluate() {
  return (
    <div className="w-full relative bg-[#f8ffff] lg:px-[120px] py-[40px]">
      <div className="container mx-auto p-3 relative">
        <div className="flex flex-col gap-3 relative">
          <p className="text-[28px] text-[#033F6A] font-semibold lg:text-[36px]">
            Đánh giá từ đối tác và khách hàng
          </p>
          <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] lg:hidden bg-[#27C6FF] flex items-center justify-center">
            <p className="text-[16px] font-semibold text-white">BlueSkyIT</p>
          </div>
          <p className="text-[16px] font-normal text-[#1F1F1F]">
            Chúng tôi luôn nhận được sự tin tưởng và đánh giá cao từ các đối tác
            và khách hàng. Đây là động lực giúp BlueskyIT không ngừng phát
            triển.
          </p>
        </div>

        <div className="w-full lg:pt-4 relative">
          <div className="block lg:hidden mt-14 ">
            <Swiper spaceBetween={20} slidesPerView={1} className="mySwiper">
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[290px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Tôi đã sử dụng sản phẩm dầu bơ ép lạnh Keyavo và thấy làn
                      da mềm mại, mịn màng hơn hẳn. Đặc biệt là không hề bị nhờn
                      dính. Cảm ơn BlueSkyIT
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[290px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Tôi rất ấn tượng với dầu trộn salad từ bơ Keyavo. Hương vị
                      nguyên bản của salad được giữ trọn vẹn và còn tốt cho sức
                      khỏe mọi người
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 w-full">
                    <div>
                      <img
                        src={tar1}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Minh Châu
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        HLV Yoga
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[290px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Đội ngũ BlueSkyIT rất chuyên nghiệp và tận tâm. Họ luôn
                      lắng nghe ý kiến của khách hàng và cải tiến sản phẩm phù
                      hợp với nhu cầu thực tế.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 w-full">
                    <div>
                      <img
                        src={tar2}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Nguyễn Hồng Nam
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        Giám đốc trung tâm giáo dục
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[290px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      BlueSkyIT có đội ngũ hỗ trợ vô cùng tận tình. Sản phẩm của
                      họ giúp tối ưu hóa hoạt động cho trung tâm giáo dục của
                      chúng tôi và nâng cao trải nghiệm học tập cho học sinh.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 w-full">
                    <div>
                      <img
                        src={tar3}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Nguyễn Thanh Tùng
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        Giám đốc trung tâm giáo dục
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="hidden lg:block">
            <Swiper
              spaceBetween={20}
              slidesPerView={3}
              breakpoints={{
                sm: {
                  slidesPerView: 7,
                },
                lg: {
                  slidesPerView: 10,
                },
              }}
              className="mySwiper relative"
            >
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3 h-[140px]">
                    <p>
                      Tôi đã sử dụng sản phẩm dầu bơ ép lạnh Keyavo và thấy làn
                      da mềm mại, mịn màng hơn hẳn. Đặc biệt là không hề bị nhờn
                      dính. Cảm ơn BlueSkyIT
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3 h-[140px]">
                    <p>
                      Tôi rất ấn tượng với dầu trộn salad từ bơ Keyavo. Hương vị
                      nguyên bản của salad được giữ trọn vẹn và còn tốt cho sức
                      khỏe mọi người
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={tar1}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Minh Châu
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        HLV Yoga
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3 h-[140px]">
                    <p>
                      Đội ngũ BlueSkyIT rất chuyên nghiệp và tận tâm. Họ luôn
                      lắng nghe ý kiến của khách hàng và cải tiến sản phẩm phù
                      hợp với nhu cầu thực tế.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={tar2}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Nguyễn Hồng Nam
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        Giám đốc trung tâm giáo dục
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px]">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3 h-[140px]">
                    <p>
                      BlueSkyIT có đội ngũ hỗ trợ vô cùng tận tình. Sản phẩm của
                      họ giúp tối ưu hóa hoạt động cho trung tâm giáo dục của
                      chúng tôi và nâng cao trải nghiệm học tập .
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={tar3}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Nguyễn Thanh Tùng
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        Giám đốc trung tâm giáo dục
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
